import { useNavigate } from "react-router-dom";
import { usePais } from "@/context/PaisContext";
import { ShieldCheck } from "lucide-react";

const OPCIONES = [
  { code: "es", flag: "🇪🇸", nombre: "España", desc: "Planes de PRL conforme a la normativa española (Ley 31/1995, RD 39/1997…).", to: "/" },
  { code: "ch", flag: "🇨🇭", nombre: "Suiza", desc: "Documentación preventiva para cantones francófonos (LAA/UVG, OPA/VUV, CFST, SUVA…).", to: "/ch" },
];

export default function SeleccionarPais() {
  const { setPais } = usePais();
  const navigate = useNavigate();
  const elegir = (o) => { setPais(o.code); navigate(o.to); };

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-6" data-testid="pais-selector">
      <div className="flex items-center gap-3 mb-10">
        <div className="w-12 h-12 rounded-xl bg-blue-700 flex items-center justify-center">
          <ShieldCheck className="w-7 h-7 text-white" />
        </div>
        <div>
          <div className="text-white font-heading font-bold text-2xl tracking-tight">PREVELIS</div>
          <div className="text-slate-400 text-sm">Selecciona tu país de trabajo</div>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 w-full max-w-3xl">
        {OPCIONES.map((o) => (
          <button
            key={o.code}
            onClick={() => elegir(o)}
            data-testid={`pais-${o.code}`}
            className="text-left bg-slate-900 border border-slate-800 rounded-2xl p-7 hover:border-blue-500 hover:bg-slate-900/60 transition-colors"
          >
            <div className="text-5xl mb-4">{o.flag}</div>
            <div className="text-white font-heading font-bold text-2xl">{o.nombre}</div>
            <p className="text-slate-400 text-sm mt-2">{o.desc}</p>
          </button>
        ))}
      </div>
      <p className="text-slate-500 text-xs mt-10">Podrás cambiar de país en cualquier momento desde la cabecera.</p>
    </div>
  );
}
